import { TypeEndereco, TypeEstado, TypeMunicipio } from "../Models/Pessoa/Endereco";
import { Dayjs } from "dayjs"
import { EnderecoService, InformacoesDoViaCEP } from "../Services/EnderecoService";

export type DatasPossiveis = undefined | string | Date | Dayjs;

export const Sanitizacoes = {
    CNPJ: "./-_"
}

export const somenteDigitos = (valor?: string): string | undefined => valor == undefined ? undefined : [...valor.matchAll(/\d/g)].reduce((prev, cur) => prev + cur[0], "");

export const sanitizar = (chars: string, valor?: string) => {
    if (valor == undefined) return undefined;

    chars.split('').forEach((ch) => {
        // @ts-ignore
        valor = valor.replaceAll(ch, '') 
    })

    return valor
}

export const formatarCNPJ = (cnpj?: string) => {
    if(cnpj == undefined) return undefined;

    if (cnpj.length != 14) return cnpj;
    return `${cnpj.slice(0, 2)}.${cnpj.slice(2, 5)}.${cnpj.slice(5, 8)}/${cnpj.slice(8, 12)}-${cnpj.slice(12, 14)}`
}

export const formatarCPF = (cpf?: string) => {
    if(cpf == undefined) return;

    const digitos = [...cpf.matchAll(/\d/g)].reduce((prev, cur) => prev + cur[0], "");
    if(digitos.length != 11) return;

    return `${digitos.slice(0, 3)}.${digitos.slice(3, 6)}.${digitos.slice(6, 9)}-${digitos.slice(9, 11)}`
}

export const formatarEndereco = (endereco: TypeEndereco) => {
    return `${endereco.logradouro}, ${endereco.numero}, ${endereco.bairro}, ${endereco.municipio?.nome} - ${endereco.estado?.sigla ?? endereco.estado?.nome}, ${endereco.cep}.`
}

export const formatarReal = (valor?: number) => {
    if(!valor && valor != 0) return null;

    return ((valor).toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
    })); 

}

export const paraData = (val: DatasPossiveis): Date | undefined => {
    if (val == undefined) return;
    if (val instanceof (Date)) return val;
    if (typeof (val) == "string") return new Date(val);

    return val.toDate();
}

export const bytesParaHumanos = (bytes: number) => {
    let units = ['B', 'KB', 'MB', 'GB', 'TB', 'PB']

    let i = 0
    
    for (i; bytes > 1024; i++) {
        bytes /= 1024;
    }

    return bytes.toFixed(1) + ' ' + units[i]
}

export const viaCepParaEndereco = async (
    info: InformacoesDoViaCEP,
    estadosDisponiveis?: TypeEstado[],
): Promise<Partial<TypeEndereco>> => {

    const enderecoService = new EnderecoService();

    let estado: TypeEstado | undefined;
    let municipio: TypeMunicipio | undefined;

    if(estadosDisponiveis == undefined) estadosDisponiveis = (await enderecoService.listarEstados()).data;
    estado = estadosDisponiveis.find((est) => est.sigla?.toLowerCase() === info.uf?.toLowerCase());

    if (estado) {
        municipio = await enderecoService.listarMunicipios({ codigo: estado.codigo })
            .then((res) => {
                const municipio = res.data.find((mun) => mun.codMunicipio === Number(info.ibge));
                return municipio
            })
    }

    return {
        estado: estado,
        municipio: municipio,
        logradouro: info.logradouro,
        bairro: info.bairro
    }

}

export function ehEmail(email:string) {
    return /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/.test(email.toLowerCase());
}

export class Formatacoes {
    static somenteDigitos = somenteDigitos
    static sanitizar = sanitizar
    static formatarCNPJ = formatarCNPJ;
    static formatarCPF = formatarCPF;
    static formatarEndereco = formatarEndereco;
    static formatarReal = formatarReal;
    static paraData = paraData;
    static viaCepParaEndereco = viaCepParaEndereco;
    static bytesParaHumanos = bytesParaHumanos;
}

export default Formatacoes
